var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("Họ tên")]),
      _c("input", {
        staticClass: "form-control",
        attrs: { readonly: "", type: "text", placeholder: "Họ tên đầy đủ" },
        domProps: {
          value: _vm.customer.FirstName + " " + _vm.customer.LastName
        }
      })
    ]),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("Điện thoại")]),
      _c("input", {
        staticClass: "form-control",
        attrs: { readonly: "", type: "text", placeholder: "" },
        domProps: {
          value:
            "(" + _vm.customer.PhonePrefix + ") " + _vm.customer.PhoneNumber
        }
      })
    ]),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("Địa chỉ")]),
      _c("textarea", {
        staticClass: "form-control",
        attrs: { readonly: "", placeholder: "Địa chỉ", rows: "3" },
        domProps: { value: _vm.customer.Address }
      })
    ]),
    _vm._m(1),
    _c("div", { staticClass: "store-area-box" }, [
      _c(
        "ul",
        _vm._l(_vm.storeAreas, function(store) {
          return _c("li", { key: store.value }, [
            _c("div", { staticClass: "box-left" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(store.name) +
                  "\n                "
              )
            ]),
            _c("div", { staticClass: "box-right" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-sm btn-block",
                  class: {
                    "btn-danger":
                      _vm.customer &&
                      _vm.customer.ReceivePlaceID === store.value,
                    "btn-default btn-un-select":
                      _vm.customer &&
                      _vm.customer.ReceivePlaceID !== store.value
                  },
                  attrs: { href: "javascript: void(0)" }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.customer &&
                          _vm.customer.ReceivePlaceID === store.value
                          ? "Mặc định"
                          : "Chọn"
                      ) +
                      "\n                    "
                  )
                ]
              )
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Địa chỉ giao nhận")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Kho nhận hàng")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }